import { Base64 } from 'js-base64';
import { decode, encode, getCookie, removeCookie, setCookie } from './utils';
export var ExpressCookies = function (req) { return ({
    setTokens: function () { },
    getTokens: function () {
        var _a = req.cookies || {}, kcIdToken = _a.kcIdToken, kcToken = _a.kcToken;
        return {
            idToken: kcIdToken ? Base64.decode(kcIdToken) : undefined,
            token: kcToken ? Base64.decode(kcToken) : undefined,
        };
    },
    resetTokens: function () { },
}); };
export var SSRCookies = function (cookies) { return ({
    setTokens: function (_a) {
        var idToken = _a.idToken, token = _a.token;
        !!token && setCookie('kcToken', encode(token));
        !!idToken && setCookie('kcIdToken', encode(idToken));
    },
    getTokens: function () {
        var tknStr = getCookie('kcToken', cookies);
        var idTknStr = getCookie('kcIdToken', cookies);
        return {
            idToken: idTknStr ? decode(idTknStr) : '',
            refreshToken: '',
            token: tknStr ? decode(tknStr) : '',
        };
    },
    resetTokens: function () {
        removeCookie('kcToken');
        removeCookie('kcIdToken');
    },
}); };
//# sourceMappingURL=server.js.map